import React, { useContext, useState } from 'react';
import { message } from 'antd';
import { getAxiosTokenInstance } from '../../../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../../../context/FirebaseContext';
import { getDayBook } from '../../../../NecttosComp/APICaller/ApiServices';
import SearchableInput from '../../../../NecttosComp/Input/SearchableImput';
import { Body, Main } from '../../../../NecttosComp/Layout/Layout';
import Button from '../../../../NecttosComp/Button/Button';
import Input2 from '../../../../NecttosComp/Input/Input2';

export const exportPdfCollectionReport = async (data) => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.post(`/college/reportGeneration/generateCollectionReport`, data, {
			responseType: 'blob',
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const JournalEntry = ({
	onClose,
	datavalues,
	setStateData,
	stateData,
	setAutoFetch = () => {},
}) => {
	const { collegeId } = useContext(FirebaseContext);
	const [date, setDate] = useState({});
	const { data = [], refetch } = useQuery('getDayBoook', getDayBook(collegeId, date.date));
	const [isLoading, setIsLoading] = useState(false);

	const fromAccounts = data.mainAccounts || [];
	const toAccounts = data.mainAccounts || [];

	const [state, setState] = useState({
		date: '',
		from: '',
		to: '',
		amount: '',
		naration: '',
		paidTo: '',
		linkId: '',
		...datavalues,
	});

	const makeEntry = async () => {
		try {
			const entryData = {
				collegeId,
				type: 'payment',
				date: state.date,
				from: state.from,
				to: state.to,
				naration: state.naration,
				paidTo: state.paidTo,
				linkId: state.linkId,
				amount: isNaN(Number(state.amount)) ? 0 : Number(state.amount),
			};

			setIsLoading(true);
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/fees/accounts', entryData);

			message.success(resp?.message || 'Journal Posted');
			setState({
				date: '',
				from: '',
				to: '',
				amount: '',
				naration: '',
				paidTo: '',
				linkId: '',
			});
			setStateData({
				...stateData,
				data: [],
				from: '',
				naration: '',
				paidTo: '',
				to: '',
				amount: '',
				linkId: '',
			});
			setAutoFetch(true);
			setStateData((prev) => ({ ...prev, showEdit: false }));
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	const clearForm = () => {
		setState({
			date: '',
			from: '',
			to: '',
			amount: '',
			naration: '',
			paidTo: '',
			linkId: '',
		});
		setStateData({
			...stateData,
			values: {},
		});
	};

	return (
		<Main title='Journal Entry' height='100vh' width='40vw' zIndex='300'>
			<div className='flex h-auto justify-end pb-2'>
				<Button type='fetch' onClick={clearForm}>
					Clear
				</Button>
				<Button type='close' onClick={onClose}>
					Close
				</Button>
			</div>
			<Body>
				<div>
					<div className='flex justify-center'>
						<Input2
							type='date'
							fieldName='From Date*'
							returnKey='date'
							state={state}
							setState={setState}
							className='w-full max-w-md'
							didntShowKey
						/>
					</div>
					<Input2
						type='drop'
						fieldName='From Account*'
						returnKey='from'
						state={state}
						setState={setState}
						options={fromAccounts}
						optionKey='_id'
						optionDisplay='name'
						className='w-full'
						didntShowKey
					/>

					<Input2
						type='drop'
						fieldName='To Account*'
						returnKey='to'
						state={state}
						setState={setState}
						options={toAccounts}
						optionKey='_id'
						optionDisplay='name'
						className='w-full'
						didntShowKey
					/>

					<Input2
						type='number'
						fieldName='Amount*'
						returnKey='amount'
						state={state}
						setState={setState}
						className='w-full'
					/>

					<SearchableInput keyData='paidTo' titleData='Paid To' collection='accounts' stateData={state} setStateData={setState} />
					<SearchableInput keyData='naration' titleData='Naration' collection='accounts' stateData={state} setStateData={setState} />

					<Input2
						type='number'
						fieldName={`Receipt No ${state.billNumber || ''}`}
						returnKey='receiptNo'
						state={state}
						setState={setState}
						className='w-full'
					/>

					<div className='flex justify-center'>
						<Button type='submit' width='200px' height='50px' onClick={makeEntry} loading={isLoading}>
							Post Entry
						</Button>
					</div>
				</div>
			</Body>
		</Main>
	);
};

// ✅ Fix for non-numeric error during reduce in sumWithKey
export const sumWithKey = (arr, key) =>
	arr.reduce((acc, val) => acc + (parseFloat(val?.[key]) || 0), 0);
